import { MerchantBankAuthorizationPage } from "../../../src/components/organisms/bank/MerchantBankAuthorizationPage";
import { AdminTemplate } from "../../components";
import { useParams } from "react-router-dom";

export const MerchantBankAuthorization = () => {
  const { merchantId } = useParams<{ merchantId: string }>();

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Üye İşyeri Banka Yetkilendirme",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
    >
      <MerchantBankAuthorizationPage merchantId={Number(merchantId)} />
    </AdminTemplate>
  );
};
